<div class="premium-dialog-header">
  <div class="dialog-badge-icon dialog-badge-indigo">
    <mat-icon>check_circle</mat-icon>
  </div>
  <h2>{{ 'ADMIN.ORDER_NUMBER' | translate }} {{ order.transactionId }}</h2>
</div>
<div mat-dialog-content>
  @if (!order.batIsActive) {
    <p class="m-0">{{ 'ADMIN.CONFIRM_FORCE_BAT_ACCEPTED' | translate }}</p>
  }
  @if (order.batIsActive) {
    <div>
      @if (hasAllBat === true) {
        <p class="m-0">{{ 'ADMIN.CONFIRM_FORCE_VALIDATION' | translate }}</p>
      }
      @if (hasAllBat === false) {
        <p class="m-0">{{ 'ADMIN.MISSING_BAT' | translate }}</p>
      }
    </div>
  }
</div>
@if (progress) {
  <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
}
<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()" [disabled]="progress">
    {{ 'ADMIN.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" [disabled]="(order.batIsActive && !hasAllBat) || progress" (click)="edit()">
    <mat-icon>check</mat-icon>
    {{ 'TEMPLATES.VALID' | translate }}
  </button>
</div>
